import { ApiConfig } from "../lib/request/api-config";

export const getClothingCategoryBasicApi: ApiConfig = {
  url: "/wx-api/clothing-category/basic",
  method: "get",
};
